export const LONGCHANNEL_SORTING_OPTIONS = [
  { label: 'COMPANY', value: 'companyName', isDefault: true },
  { label: 'FINANCIALMANAGER', value: 'fullName' },
  { label: 'RATING', value: 'ratingValue' },
  { label: 'EXPORTEDON', value: 'exportedOn' },
  { label: 'LASTACTIVITYCOMPLETEDON', value: 'lastActivityCompletedOn' },
];

export const LONGCHANNEL_SEARCHBOX_FILTERS = [
  'companyName',
  'fullNameSearch',
  'customerCode',
  'mobilePhoneNumber',
];

export const LONGCHANNEL_FILTERS = [
  { keyName: 'category' },
  { keyName: 'status' },
  { keyName: 'dealerRating' },
  { keyName: 'businessPackage' },
  { keyName: 'city' },
  { keyName: 'hasNationalAgreement', operator: 'eq' },
  { keyName: 'nationalAgreement' },
];

export const DYNAMIC_FEATURES_IDS = {
  profitabilityYTD: 40,
  profitability: 41,
  startingProfitability: 42,
  litigation: 43,
  overdraft: 44,
  risk: 45,
  disbursed: 46,
  disbursedYTD: 47,
  ytd: 48,
  ytd2: 49,
  cpi: 50,
  cvt: 51,
  dealerState: 52,
  segment: 53,
  dealerRating: 54,
  businessPackage: 55,
  hasNationalAgreement: 56,
  nationalAgreement: 57,
};
